import React, { useEffect, useState } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import dayjs from "dayjs";

export const NAVY = "#142C5C";

/** "Crunching the numbers" with dots cycling 1 to 3 (fixed width, no jitter). */
export const Crunching = () => {
  const [n, setN] = useState(1);
  useEffect(() => {
    const t = setInterval(() => setN((k) => (k % 3) + 1), 400);
    return () => clearInterval(t);
  }, []);
  return (
    <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
      Crunching the numbers{".".repeat(n)}
      <span style={{ visibility: "hidden" }}>{".".repeat(3 - n)}</span>
    </Typography>
  );
};

/** "Computed 2:46 AM" (or crunching) plus a refresh icon. */
export const ComputedStatus = ({ loading, computedAt, onRefresh }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: "auto" }}>
    {loading ? (
      <Crunching />
    ) : (
      computedAt && (
        <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
          Computed {dayjs(computedAt).format("h:mm A")}
        </Typography>
      )
    )}
    <Tooltip title="Refresh">
      <span>
        <IconButton
          size="small"
          aria-label="Refresh"
          disabled={loading}
          onClick={onRefresh}
        >
          <RefreshIcon fontSize="small" sx={{ color: NAVY }} />
        </IconButton>
      </span>
    </Tooltip>
  </Box>
);

/** Two-or-more option toggle matching the page's existing filter style. */
export const Segmented = ({ label, options, value, onChange }) => (
  <Box sx={{ display: "flex", alignItems: "center" }}>
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: { xs: "12px", sm: "14px", md: "15px" },
        paddingRight: "10px",
        whiteSpace: "nowrap",
      }}
    >
      {label}:
    </Typography>
    <Box
      sx={{
        display: "flex",
        borderRadius: "6px",
        overflow: "hidden",
        border: "1px solid #d9d9d9",
      }}
    >
      {options.map((opt) => (
        <Box
          key={opt.id}
          onClick={() => onChange(opt.id)}
          sx={{
            padding: "4px 14px",
            fontSize: { xs: "12px", sm: "13px", md: "14px" },
            fontWeight: 600,
            cursor: "pointer",
            backgroundColor: value === opt.id ? NAVY : "#fff",
            color: value === opt.id ? "#fff" : "#333",
            transition: "all 0.2s",
            "&:hover": { backgroundColor: value === opt.id ? NAVY : "#f0f0f0" },
          }}
        >
          {opt.label}
        </Box>
      ))}
    </Box>
  </Box>
);
